import * as yup from "yup";

export const waiterConfigValidationSchema = yup.object({
  waiter: yup.string().default("").required("Waiter name is required"),
  waiterConfigOverrides: yup
    .object({
      maxWaitTime: yup.number().optional().moreThan(0, "Max wait time must be greater than 0"),
      minDelay: yup.number().optional().moreThan(0, "Min delay must be greater than 0"),
      maxDelay: yup.number().optional().moreThan(0, "Max delay must be greater than 0"),
    })
    .optional(),
});

export type WaiterConfigSchema = yup.InferType<typeof waiterConfigValidationSchema>;
